import purchrAxios from './purchrAxios';

export default class AdminConfigService {
  static async all() {
    const response = await purchrAxios.get(`/adminConfig`);
    return response.data;
  }
}
